<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
    <g fill="none" fill-rule="evenodd">
      <path :stroke="stroke" stroke-width="2" d="M33 16l-7 19-3-9-9-3 19-7zM23 26l9-9"/>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    stroke: String
  }
}
</script>

